import { Hourglass } from 'react-loader-spinner';
import pikkoLogoWelcome from '../../styles/img/account/pikkoLogoWelcome.svg';

const ManualVerificationOverlay = () => {
  return (
    <div
      className={`transition-all duration-700 h-[100dvh] fixed w-[100vw] z-40 left-0 top-0 overflow-x-visible`}
    >
      <div
        className={
          'z-[50] !pt-[10vh] bg-gradient3 sliderNumberConnect w-[100%] transform overflow-x-visible translate-x-[-50%] left-[50%] gap-8 mx-auto flex flex-col items-center bottom-0 transition-all h-full fixed shadow-lg duration-700 slideuppopupXY'
        }
      >
        <h1 className="geomanistRegular font-bold">
          Tu y es presque !
        </h1>
        <h2 className="geomanistRegular font-bold">
          Nous allons vérifier ton panier...
        </h2>
        <div className="flex relative top-16">
          <Hourglass
            visible={true}
            height="60"
            width="60"
            ariaLabel="hourglass-loading"
            wrapperStyle={{}}
            wrapperClass=""
            colors={['#000000', '#000000']}
          />
        </div>

        <img
          src={pikkoLogoWelcome}
          alt="pikkoLogo"
          className="pikkoLogo-phone-screen animatedLogo"
        />
      </div>
    </div>
  );
};

export default ManualVerificationOverlay;